import { PageKey } from '@core/enums/page-keys.enum';
import { FlowId, type CheckinWorkflow } from '../workflow-engine.types';
import { reportToReceptionFlow } from './report-to-reception.flow';

export enum CheckinStep {
  Checkin = 'Checkin',
  Failure = 'Failure',
  SendToReception = 'SendToReception',
  AfterReception = 'AfterReception',
}

export const checkinFlow: CheckinWorkflow<CheckinStep> = {
  id: FlowId.Checkin,
  entry: CheckinStep.Checkin,
  steps: {
    [CheckinStep.Checkin]: {
      id: CheckinStep.Checkin,
      page: PageKey.CHECK_IN,
      next: (variables) =>
        variables.isCheckinSuccess ? { complete: true } : { nextStep: CheckinStep.Failure },
      back: () => ({ bubble: 'back' }),
      exit: () => ({ bubble: 'exit' }),
    },
    [CheckinStep.Failure]: {
      id: CheckinStep.Failure,
      page: PageKey.CHECK_IN_FAIL,
      next: () => ({ nextStep: CheckinStep.SendToReception }),
      back: () => ({ nextStep: CheckinStep.Checkin }),
      exit: () => ({ bubble: 'exit' }),
    },
    [CheckinStep.SendToReception]: {
      id: CheckinStep.SendToReception,
      next: () => ({ flow: reportToReceptionFlow, returnStep: CheckinStep.AfterReception }),
      back: () => ({ nextStep: CheckinStep.Failure }),
    },
    [CheckinStep.AfterReception]: {
      id: CheckinStep.AfterReception,
      next: () => ({ bubble: 'exit' }),
    },
  },
};
